export enum PaymentMethodTestIDs {
  PAYMENT_METHOD_SELECTOR_CONTAINER = 'payment-methods-container',
  PAYMENT_METHOD_CONTAINER = 'payment-method-item-container',
}
